import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/i18n/LanguageContext";
import "@/App.css";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";
import FastfoodDemo from "@/pages/demos/FastfoodDemo";
import ToejbutikDemo from "@/pages/demos/ToejbutikDemo";
import HyggeTavernDemo from "@/pages/demos/HyggeTavernDemo";
import LaegeSupportDemo from "@/pages/demos/LaegeSupportDemo";
import KedeJuiceDemo from "@/pages/demos/KedeJuiceDemo";
import KedeWaterDemo from "@/pages/demos/KedeWaterDemo";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App bg-[#050505] text-[#F2F2F2] min-h-screen">
      <LanguageProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/demo/fastfood" element={<FastfoodDemo />} />
            <Route path="/demo/toejbutik" element={<ToejbutikDemo />} />
            <Route path="/demo/hygge-tavern" element={<HyggeTavernDemo />} />
            <Route path="/demo/laege-support" element={<LaegeSupportDemo />} />
            <Route path="/demo/kede-juice" element={<KedeJuiceDemo />} />
            <Route path="/demo/kede-water" element={<KedeWaterDemo />} />
          </Routes>
        </BrowserRouter>
      </LanguageProvider>
      <Toaster position="bottom-right" theme="dark" />
    </div>
  );
}

export default App;
